import React from 'react';
import Icon, { COLORS } from '../general-components/icon';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { StylePackContentType } from '../types/stylepacks';

interface BubbleProps {
	text: string;
	icon: string;
	type?: StylePackContentType;
	onClick: (val?: StylePackContentType) => void;
}

export default function StylePackFilterBubble(props: BubbleProps) {
	const { type } = props;
	const activeFilter = useSelector((s: any) => s.UserInterfaceReducer.stylePackTypeFilter);
	const isActive = type === activeFilter;
	return <div
		data-testid="style-packs-bubble-filter"
		className={classNames(
			'style-packs-bubble-filter',
			{
				'filter-bubble-highlighted': isActive,
			}
		)}
		onClick={() => props.onClick(isActive ? undefined : type)}
	>
		{props.icon && (
			<Icon name={props.icon} color={COLORS.WHITE} size={20} />
		)}
		<span className="bl-font-c3 grayscale-100 truncate-overflow">
			{props.text}
		</span>
	</div>
}
